export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SignUp.vue?vue&type=template&id=2a05c133&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SignUp.vue?vue&type=template&id=2a05c133&scoped=true
// module id = 234
// module chunks = 0